module.exports = __webpack_public_path__ + "static/img/rank_49.6cf7e38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_49.png
// module id = POyP
// module chunks = 1